(ns ui.components.tooltip.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Tooltip/styles.json
;; Source commit: 115d80f5a88e8a5e6e3d0477ab7881d8c6f9412a
;; ----------------------------------------------------------------------------

(def tooltip
  {:bubble
   {:base
    "tw2-px-tooltip-px tw2-py-tooltip-py tw2-rounded-tooltip tw2-bg-tooltip-bg tw2-text-tooltip-text tw2-text-label-sm tw2-font-sans tw2-shadow-sm tw2-pointer-events-none tw2-max-w-xs tw2-whitespace-normal tw2-break-words tw2-transition tw2-duration-200 tw2-ease-out",
    :position {:top "", :bottom "", :left "", :right ""},
    :visible
    {:true "tw2-opacity-100",
     :false "tw2-opacity-0 tw2-pointer-events-none"},
    :compound-variants
    [{:position "top", :visible true, :class "tw2-translate-y-0"}
     {:position "top", :visible false, :class "tw2-translate-y-2"}
     {:position "bottom", :visible true, :class "tw2-translate-y-0"}
     {:position "bottom", :visible false, :class "tw2--translate-y-2"}
     {:position "left", :visible true, :class "tw2-translate-x-0"}
     {:position "left", :visible false, :class "tw2-translate-x-2"}
     {:position "right", :visible true, :class "tw2-translate-x-0"}
     {:position "right", :visible false, :class "tw2--translate-x-2"}],
    :default-variants {:position "top", :visible false}},
   :_meta
   {:tokens
    ["label-sm-font-size"
     "label-sm-font-weight"
     "label-sm-line-height"
     "radius-tooltip"
     "spacing-tooltip-px"
     "spacing-tooltip-py"
     "tooltip-bg"
     "tooltip-text"],
    :generated-from "src/components/Tooltip/Tooltip.styles.ts",
    :runtime-styles
    [{:slot "bubble",
      :property "position",
      :description
      "fixed, so the portaled bubble can sit over the trigger"}
     {:slot "bubble",
      :property "top/left",
      :description "computed from trigger position"}
     {:slot "bubble",
      :property "zIndex",
      :description "9999, above page content"}],
    :a11y
    ["Bubble has a unique id."
     "Trigger aria-describedby points at the bubble while it is rendered."]}})
